module.exports = __webpack_public_path__ + "img/interior-new.74dd3d61.jpeg";